import React, { useImperativeHandle } from "react";
import { Form, FormInputType, FormInputProps } from "@wellth/web-ui";

export interface PhoneNumberFormProps {
  phoneNumber: string;
  isPrimary: boolean;
}

export interface EditPhoneNumberFormProps
  extends Partial<PhoneNumberFormProps> {
  type: "member" | "prospect";
  disablePrimary?: boolean;
  inputStyle?: React.CSSProperties;
}

const EditPhoneNumberForm: React.RefForwardingComponent<
  any,
  EditPhoneNumberFormProps
> = (
  {
    type,
    inputStyle = {
      height: "2.1875rem",
      width: "18.75rem",
    },
    disablePrimary = false,
    ...formProps
  }: EditPhoneNumberFormProps,
  ref,
) => {
  const formRef = React.useRef(null);
  const isMember = type === "member";
  useImperativeHandle(ref, () => ({
    getPhoneNumber: () =>
      new Promise((resolve, reject) =>
        formRef.current.props.form.validateFields((errors, values) =>
          errors ? reject(errors) : resolve(values),
        ),
      ),
  }));

  return (
    <Form
      {...formProps}
      wrappedComponentRef={formRef}
      mapPropsToFields={(
        { phoneNumber, isPrimary = false },
        createFormField,
      ) => ({
        phoneNumber: createFormField({
          value: phoneNumber ? phoneNumber.slice(2) : "",
        }),
        isPrimary: createFormField({ value: isPrimary }),
      })}
      inputs={[
        {
          type: FormInputType.Mask,
          title: "Phone number:",
          key: "phoneNumber",
          mask: "999-999-9999",
          style: inputStyle,
          decoratorOptions: {
            rules: [
              {
                required: true,
                message: "Please provide a valid phone number.",
              },
            ],
          },
        },
        ...(isMember
          ? [
              {
                type: FormInputType.Switch,
                title: "Set as Verified?",
                key: "isPrimary",
                disabled: disablePrimary,
                decoratorOptions: { valuePropName: "checked" },
              } as FormInputProps,
            ]
          : []),
      ]}
      labelCol={{
        span: 7,
      }}
      wrapperCol={{
        xs: { span: 24 },
        sm: { span: 12 },
      }}
      colValue={12}
    />
  );
};

export default React.forwardRef(EditPhoneNumberForm);
